import { Action } from '../../../utils/types';
import useAction from '../../../utils/utils';

type ActionHandlerParams = {
	history: any;
	rowData: any;
};

export const makeActionHandler = (action: Action, params: ActionHandlerParams) => {
	const { onDownloadCsv } = useAction(params);
	switch (action.id) {
		case 'historicalCsvDownload':
			return () => {
				onDownloadCsv();
			};
		default:
			return () => {};
	}
};

export default {
	makeActionHandler
};
